<template>
  <div class="md-layout">
    <md-card class="md-layout-item md-size-50 md-small-size-100 margin-top-10">
      <md-card-header>
        <p class="md-title">Business limits</p>
      </md-card-header>

      <md-card-content class="information-table compact">
        <div class="md-layout" v-if="!updatingLimits">
          <div class="md-layout-item md-small-size-100 mb-2">
            <p class="md-subheading">Maximum document size</p>
            <span class="md-subheading">
              {{ enterprise.limits.documentSize }} MB
            </span>
          </div>
          <div class="md-layout-item md-small-size-100 mb-2">
            <p class="md-subheading">Maximum pages per document</p>
            <span class="md-subheading">
              {{ enterprise.limits.pagesPerDocument }}
            </span>
          </div>
        </div>

        <div class="md-layout" v-if="updatingLimits">
          <div class="md-layout-item md-size-100">
            <md-field name="documentSize">
              <label for="documentSize">Document size</label>
              <md-input
                name="documentSize"
                v-model="localEnterprise.limits.documentSize"
                placeholder="Enter size in MB (e.g. 25). Let empty to reset to default value."
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field name="pagesPerDocument">
              <label for="pagesPerDocument">Maximum pages per document</label>
              <md-input
                name="pagesPerDocument"
                v-model="localEnterprise.limits.pagesPerDocument"
                placeholder="Enter number of pages per document this business can send."
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-button class="md-raised" @click="updateLimits">
              Save
            </md-button>
          </div>
        </div>
        <div class="md-layout" v-if="!updatingLimits">
          <md-button class="md-raised" @click="requestUpdateLimits">
            Update limits
          </md-button>
        </div>
      </md-card-content>
    </md-card>
    <snackbar-message-handler :message="errorMessage"></snackbar-message-handler>
  </div>
</template>
<style lang="scss">
.md-app-content .md-card.invoice-return {
  margin: 16px 0;
}
.composed-items span {
  display: inline-block;
}
.space-after::after {
  content: ' ';
  display: block;
  width: 7px;
}
</style>
<script type="ts">
import camelcaseKeysDeep from 'camelcase-keys-deep';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import EnterpriseLimits from '@/datatypes/enterprise/limits';
import Enterprise from '@/datatypes/enterprise';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import EnterpriseUpdateLimitsRequest from '@/datatypes/enterprise/update-limits-request';

export default {
  components: {
    SnackbarMessageHandler,
  },
  name: 'enterprise-limits-view',
  props: {
    enterprise: {
      type: Enterprise,
      required: true,
    },
  },
  methods: {
    updateLimits() {
      const enterpriseId = this.$route.params.id;
      const updateParams = new EnterpriseUpdateLimitsRequest(this.enterprise.limits);

      this.enterpriseService.updateEnterpriseLimits(enterpriseId, updateParams).then((response) => {
        this.updatingLimits = false;
        this.localEnterprise.limits = new EnterpriseLimits(camelcaseKeysDeep(response.data));
        this.errorMessage = 'Enterprise limits updated.';
      }).catch((error) => {
        this.$emit('enterpriseReload', () => {
          this.updatingLimits = false;
          this.errorMessage = error.response.data.message;
        });
      });
    },
    requestUpdateLimits() {
      this.updatingLimits = true;
    },
  },
  computed: {
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },
  data: () => ({
    errorMessage: '',
    updatingLimits: false,
    enterpriseService: new EnterpriseService(),
    snackbarMessage: '',
  }),
};
</script>
